// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ContractType,
    ContractTypeFromJSON,
    ContractTypeToJSON,
    CoverageType,
    CoverageTypeFromJSON,
    CoverageTypeToJSON,
    PlaceOfServiceType,
    PlaceOfServiceTypeFromJSON,
    PlaceOfServiceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportCreateChargemasterItemPayload
 */
export interface SupportCreateChargemasterItemPayload {
    /**
     * The procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    procedure?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportCreateChargemasterItemPayload
     */
    modifiers?: Array<string>;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateChargemasterItemPayload
     */
    amount: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateChargemasterItemPayload
     */
    accepted?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateChargemasterItemPayload
     */
    expected?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateChargemasterItemPayload
     */
    medicare?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateChargemasterItemPayload
     */
    patient?: Amount;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    wrvu?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    rvu?: string;
    /**
     * Does the procedure code require the claim to have a prior authorization code?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportCreateChargemasterItemPayload
     */
    authorization?: boolean;
    /**
     * Does the procedure code require the claim to have a paperwork attachment?
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportCreateChargemasterItemPayload
     */
    paperwork?: boolean;
    /**
     * The patient description of the procedure
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    description?: string;
    /**
     * 
     * OpenAPI data type: {PlaceOfServiceType}
     * @type {PlaceOfServiceType}
     * @memberof SupportCreateChargemasterItemPayload
     */
    placeOfServiceType?: PlaceOfServiceType;
    /**
     * The payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    payerId?: string;
    /**
     * 
     * OpenAPI data type: {CoverageType}
     * @type {CoverageType}
     * @memberof SupportCreateChargemasterItemPayload
     */
    coverage?: CoverageType;
    /**
     * The billing provider id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    billingProviderId?: string;
    /**
     * The rendering provider id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    providerId?: string;
    /**
     * The facility id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateChargemasterItemPayload
     */
    facilityId?: string;
    /**
     * 
     * OpenAPI data type: {ContractType}
     * @type {ContractType}
     * @memberof SupportCreateChargemasterItemPayload
     */
    contract?: ContractType;
}

export function SupportCreateChargemasterItemPayloadFromJSON(json: any): SupportCreateChargemasterItemPayload {
    return {
            'procedure': !exists(json, 'procedure') ? undefined : json['procedure'],
            'modifiers': !exists(json, 'modifiers') ? undefined : json['modifiers'],
            'amount': AmountFromJSON(json['amount']),
            'accepted': !exists(json, 'accepted') ? undefined : AmountFromJSON(json['accepted']),
            'expected': !exists(json, 'expected') ? undefined : AmountFromJSON(json['expected']),
            'medicare': !exists(json, 'medicare') ? undefined : AmountFromJSON(json['medicare']),
            'patient': !exists(json, 'patient') ? undefined : AmountFromJSON(json['patient']),
            'wrvu': !exists(json, 'wrvu') ? undefined : json['wrvu'],
            'rvu': !exists(json, 'rvu') ? undefined : json['rvu'],
            'authorization': !exists(json, 'authorization') ? undefined : json['authorization'],
            'paperwork': !exists(json, 'paperwork') ? undefined : json['paperwork'],
            'description': !exists(json, 'description') ? undefined : json['description'],
            'placeOfServiceType': !exists(json, 'placeOfServiceType') ? undefined : PlaceOfServiceTypeFromJSON(json['placeOfServiceType']),
            'payerId': !exists(json, 'payerId') ? undefined : json['payerId'],
            'coverage': !exists(json, 'coverage') ? undefined : CoverageTypeFromJSON(json['coverage']),
            'billingProviderId': !exists(json, 'billingProviderId') ? undefined : json['billingProviderId'],
            'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
            'facilityId': !exists(json, 'facilityId') ? undefined : json['facilityId'],
            'contract': !exists(json, 'contract') ? undefined : ContractTypeFromJSON(json['contract']),
    };

}

export function SupportCreateChargemasterItemPayloadToForm(value?: SupportCreateChargemasterItemPayload): any {
    let jsonVal = SupportCreateChargemasterItemPayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateChargemasterItemPayloadToJSON(value?: SupportCreateChargemasterItemPayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'procedure': cleanupBlankValuesForBackend(value.procedure),
            'modifiers': cleanupBlankValuesForBackend(value.modifiers),
            'amount': AmountToJSON(value.amount),
            'accepted': AmountToJSON(value.accepted),
            'expected': AmountToJSON(value.expected),
            'medicare': AmountToJSON(value.medicare),
            'patient': AmountToJSON(value.patient),
            'wrvu': cleanupBlankValuesForBackend(value.wrvu),
            'rvu': cleanupBlankValuesForBackend(value.rvu),
            'authorization': cleanupBlankValuesForBackend(value.authorization),
            'paperwork': cleanupBlankValuesForBackend(value.paperwork),
            'description': cleanupBlankValuesForBackend(value.description),
            'placeOfServiceType': PlaceOfServiceTypeToJSON(value.placeOfServiceType),
            'payerId': cleanupBlankValuesForBackend(value.payerId),
            'coverage': CoverageTypeToJSON(value.coverage),
            'billingProviderId': cleanupBlankValuesForBackend(value.billingProviderId),
            'providerId': cleanupBlankValuesForBackend(value.providerId),
            'facilityId': cleanupBlankValuesForBackend(value.facilityId),
            'contract': ContractTypeToJSON(value.contract),
    };
}


